import { Component, OnInit } from '@angular/core';
import { DomSanitizer, SafeResourceUrl, SafeUrl} from '@angular/platform-browser';

	
@Component({
  selector: 'app-terms',
  templateUrl: './terms.component.html'
})
export class TermsComponent implements OnInit {

  constructor(private sanitizer: DomSanitizer) { }

	title: string;
	header: any;
	headerHeight: any;
	headerAlign: any;
	subtitle: string;

  /* On with the show */
ngOnInit() {

		this.title = 'Terms';
		this.header = this.sanitizer.bypassSecurityTrustStyle( 'url( "/assets/img/header-shop.jpg")' );
		this.subtitle = 'Terms of Service';
  		this.headerHeight = '400px';
  }

}



// WEBPACK FOOTER //
// C:/Users/Asylum/identity-vagrant/src/asylum-idenetity/src/app/terms/terms.component.ts